// @flow
import React, { Component } from 'react';


import { NavHashLink as NavLink } from "react-router-hash-link";
import SamplePopup from '../SamplePopup';

import LazyLoad from 'react-lazyload';

import './NewHome.scss';
import NewHomeHeader from './NewHomeHeader/NewHomeHeader';

export default class NewHome extends Component {

  constructor(props) {
    super(props);

    this.state = {
      activeSection: "",
      popupForm: false,
    }


  }
  scrollWithOffset = (el, offset) => {
    const elementPosition = el.offsetTop - offset;
    if (typeof window !== "undefined") {
      window.scroll({
        top: elementPosition,
        left: 0,
        behavior: "smooth"
      });
    }
  };

  handleScroll = e => {
    let element = e.target
    console.log("element.scrollHeight - element.scrollTop")
    console.log(element.scrollHeight - element.scrollTop)
    if (element.scrollHeight - element.scrollTop === element.clientHeight) {
      this.setState({ popupForm: true });
     
    }
  }


  openPopupForm = () => {
    this.setState({ popupForm: true });
  }

  closePopupForm = () => {
    this.setState({ popupForm: false });
  }


  hideCol = (column) => {
    if(column==="left") {
      document.querySelector("#left-col").classList.add("hidden-col")
    } else {
      document.querySelector("#right-col").classList.add("hidden-col")
    }
    
  }

  showCol = (column) => {
    if(column==="left") {
      document.querySelector("#left-col").classList.remove("hidden-col")
    } else {
      document.querySelector("#right-col").classList.remove("hidden-col")
    }
    
  }

  render() {


    return (
      <section className="new-home__lp">
       
        <div className="new-home__container" > 
       
            <div className="row new-home__row">
            <NewHomeHeader  />
              <div id="left-col" onMouseEnter={() => this.hideCol("right")} onMouseLeave={() => this.showCol("right")}  className="new-home__left-col">
                
                <div className="nav-container">
                  <NavLink
                    className={
                      "big-btn__link"
                    }
                    to={"/dach"}
                  >
                    Renowacja dachu
                  </NavLink>
                  <div className="nav-links__container">
                    <NavLink
                      to={"/dach/#roof-step1"}
                      smooth
                      scroll={el => this.scrollWithOffset(el, 178, "roof-step1")}
                      onClick={e => {
                        if (window.location.pathname == "/dach/#roof-step1") {
                          e.preventDefault();
                        }
                        
                      }}
                      className={
                        "nav-link" 
                      }
                    >
                      Szybkie gruntowanie
                    </NavLink>
                    <span className="spacer"></span>
                    <NavLink
                      to={"/dach/#roof-step2"}
                      smooth
                      scroll={el => this.scrollWithOffset(el, -278, "roof-step2")}
                      onClick={e => {
                        if (window.location.pathname == "/dach/#roof-step2") {
                          e.preventDefault();
                        }
                        
                      }}
                      className={
                        "nav-link" 
                      }
                    >
                      Szybkie szpachlowanie
                    </NavLink>
                    <span className="spacer"></span>
                    <NavLink
                      to={"/dach/#roof-step3"}
                      smooth
                      scroll={el => this.scrollWithOffset(el, -278, "roof-step3")}
                      onClick={e => {
                        if (window.location.pathname == "/dach/#roof-step3") {
                          e.preventDefault();
                        }
                        
                      }}
                      className={
                        "nav-link" 
                      }
                    >
                      Szybka powłoka
                    </NavLink>
                  </div>
                  
                </div>
              </div>
              <div className="new-home__mid"></div>
              <div className="spliter"></div>
              <div id="right-col" onMouseEnter={() => this.hideCol("left")} onMouseLeave={() => this.showCol("left")}  className="new-home__right-col">
              <div className="nav-container">
                  <NavLink
                    className={
                      "big-btn__link"
                    }
                    to={"/fundamenty"}
                  >
                    hydroizolacja fundamentu
                  </NavLink>
                  <div className="nav-links__container">
                    <NavLink
                      to={"/fundamenty/#foundation1"}
                      smooth
                      scroll={el => this.scrollWithOffset(el, 178, "foundation1")}
                      onClick={e => {
                        if (window.location.pathname == "/fundamenty/#foundation1") {
                          e.preventDefault();
                        }
                        
                      }}
                      className={
                        "nav-link" 
                      }
                    >
                      hydroizolacja przeciwwilgociowa
                    </NavLink>
                    <span className="spacer"></span>
                    <NavLink
                      to={"/fundamenty/#foundation2"}
                      smooth
                      scroll={el => this.scrollWithOffset(el, 100, "foundation2")}
                      onClick={e => {
                        if (window.location.pathname == "/fundamenty/#foundation2") {
                          e.preventDefault();
                        }
                        
                      }}
                      className={
                        "nav-link" 
                      }
                    >
                      hydroizolacja przeciwwodna
                    </NavLink>

                  </div>

                </div>
              
              </div>
            </div>  
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NewHome/NewHome.js